import { Routes } from '@angular/router';
import { guestGuard } from './features/auth/guards/guest.guard';
import { authGuard } from './features/auth/guards/auth.guard';
import { MainLayout } from './layouts/views/main-layout/main-layout';

export const routes: Routes = [
  {
    path: '',
    component: MainLayout,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/home/home.routes').then(m => m.homeRoutes),
      },
      {
        path: 'auth',
        canActivate: [guestGuard],
        loadChildren: () =>
          import('./features/auth/auth.routes').then(m => m.authRoutes),
      },
      {
        path: 'about-us',
        loadChildren: () =>
          import('./features/about-us/about-us.routes').then(
            m => m.aboutUsRoutes
          ),
      },
      {
        path: 'testimonials',
        loadChildren: () =>
          import('./features/testimonials/testimonials.routes').then(
            m => m.testimonialsRoutes
          ),
      },
      {
        path: 'legal',
        loadChildren: () =>
          import('./features/legal/legal.routes').then(m => m.legalRoutes),
      },
      {
        path: 'faq',
        loadChildren: () =>
          import('./features/faq/faq.routes').then(m => m.faqRoutes),
      },
      {
        path: 'complaints-book',
        loadChildren: () =>
          import('./features/complaints-book/complaints-book.routes').then(
            m => m.complaintsBookRoutes
          ),
      },
      {
        path: 'not-found',
        loadChildren: () =>
          import('./features/not-found/not-found.routes').then(
            m => m.notFoundRoutes
          ),
      },
      {
        path: 'teachers',
        loadChildren: () =>
          import('./features/teachers/teachers.routes').then(
            m => m.teachersRoutes
          ),
      },
      {
        path: 'certificate',
        redirectTo: 'certificates',
        pathMatch: 'full',
      },
      {
        path: 'certificates',
        loadChildren: () =>
          import('./features/certificates/certificates.routes').then(
            m => m.certificatesRoutes
          ),
      },
      {
        path: 'courses',
        loadChildren: () =>
          import('./features/courses/courses.routes').then(
            m => m.coursesRoutes
          ),
      },
      {
        path: 'my-courses',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./features/courses/my-courses.routes').then(
            m => m.myCoursesRoutes
          ),
      },
      {
        path: 'cart',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./features/cart/cart.routes').then(m => m.cartRoutes),
      },
      {
        path: 'account',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./features/account/account.routes').then(
            m => m.accountRoutes
          ),
      },
      {
        path: 'calendar',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./features/calendar/calendar.routes').then(
            m => m.calendarRoutes
          ),
      },
      {
        path: 'classroom',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./features/classroom/classroom.routes').then(
            m => m.classroomRoutes
          ),
      },
      {
        path: 'exams',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./features/exams/exam.routes').then(m => m.examRoutes),
      },
      {
        path: 'purchase-history',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./features/purchase-history/purchase-history.routes').then(
            m => m.purchaseHistoryRoutes
          ),
      },
    ],
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./features/payments/payments.routes').then(m => m.paymentsRoutes),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
